/**
 * Image format support utilities - extracted to break circular dependency
 * between THREEAssetLoader.ts and browserLoader.ts
 */

export enum ImageFormatFeature {
  WEBP_LOSSY,
  WEBP_LOSSLESS,
  WEBP_ALPHA,
  WEBP_ANIMATION,
  AVIF,
}

// Adapted from https://developers.google.com/speed/webp/faq#how_can_i_detect_browser_support_for_webp
export function browserCheckImageFormatSupport(feature: ImageFormatFeature): Promise<boolean> {
  return new Promise((resolve, _reject) => {
    if (typeof Image === "undefined") {
      // This code can be run in a web worker, in which case the Image API is not available.
      resolve(false);
      return;
    }
    const testImages: { [key in ImageFormatFeature]: string } = {
      [ImageFormatFeature.WEBP_LOSSY]: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
      [ImageFormatFeature.WEBP_LOSSLESS]: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
      [ImageFormatFeature.WEBP_ALPHA]:
        "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
      [ImageFormatFeature.WEBP_ANIMATION]:
        "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
      [ImageFormatFeature.AVIF]:
        "AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=",
    };
    const img: HTMLImageElement = new Image();
    img.onload = function () {
      const result = img.width > 0 && img.height > 0;
      resolve(result);
    };
    img.onerror = function () {
      resolve(false);
    };

    let mimeType = "image/webp";
    if (feature === ImageFormatFeature.AVIF) {
      mimeType = "image/avif";
    }
    img.src = `data:${mimeType};base64,${testImages[feature]}`;
  });
}
